import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { MultiColumnRichTextEntry } from "frontend/contentful/schema/blocks";
import { MultiColumnRichTextProps } from "design-system/components/blocks/multi-column-rich-text/multi-column-rich-text";
import { RichText } from "design-system/components/blocks/rich-text/rich-text";
import { MultiColumnRichTextOptions } from "./multi-column-rich-text.contentful";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";

export const createMultiColumnRichTextProps = createContentfulProps<
  MultiColumnRichTextEntry,
  MultiColumnRichTextProps,
  MultiColumnRichTextOptions
>(({ entry, options, createEditAttributes }) => {
  const headerAbove = options?.headerAbove || false;

  const props: MultiColumnRichTextProps = {
    headerContent: createComponentHeaderProps(entry.fields.header),
    HeadingLevel: headerAbove ? "h3" : "h2",
    content: (
      <RichText
        editAttribute={createEditAttributes({ entry, fieldId: "content" })}
      >
        <RenderContentfulRichText document={entry.fields.content} />
      </RichText>
    ),
    align: entry.fields.alignment,
  };

  return props;
});
